<template>
  <div class="mt-10">
    <p class="parragraph-h-20">{{$t("step.enter_card_details")}}</p>
    <div class="mt-6">
      <div class="my-input-name">
        <input
          type="text"
          name="name"
          id="cardName"
          v-model="cardName"
          class="w-full"
          :placeholder="$t('shared.name_on_the_card') + '*'"
        />
      </div>
      <div id="card-name-errors" role="alert"></div>
    </div>

    <div class="mt-6 my-input" id="card-element">
      <!-- Elements will create input elements here -->
    </div>
    <div id="card-errors" role="alert"></div>
    <!-- We'll put the error messages in this element -->
    <button class="hidden" id="submit-stripe"></button>
  </div>
</template>

<script>
import { handleServerResponse } from "../../utils/stripe";
import prepareChoice from "../../utils/prepareReservation";
import stepMixin from "../../utils/mixins/stepMixin";
import { SET_SNACKBAR } from "../../store/snackbar/mutation-types";
import { SET_STEPPER_LOADING } from "../../store/stepper/action-types";
import moment from "../../plugins/moment";

export default {
  mixins: [stepMixin],
  props: {
    gift: {
      type: Boolean,
      default: false,
    },
    nights: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    stripeKey: window.stripeKey,
    cardName: "",
  }),
  computed: {
    choice() {
      let choice = "default";
      if (this.nights) {
        choice = "nights";
      } else if (this.gift) {
        choice = "gift";
      }
      return choice;
    },
  },
  methods: {
    checkoutPayment(paymentMethod, card_name) {
      axios
        .post("/api/stripe/create-order", {
          reservation: JSON.stringify(prepareChoice(this.choice)),
          gift: this.gift ? 1 : 0,
          nights: this.nights ? 1 : 0,
          payment_method: paymentMethod,
          card_name: card_name,
          user_timezone: moment.tz.guess()
        })
        .then(async (res) => {
          const response = await handleServerResponse(res.data);
          if (response.error) {
            throw response.error;
          } else if (response.needComfirm) {
            axios.post("/api/reservation/paid-status", {
              payment_intent_id: response.paymentIntent.id,
            });
          }

          const code = res.data.reservation_code;
          let path;
          if (this.gift) {
            path = `/regala/${code}/confirmacion`;
          } else {
            path = `/viaje/${code}/confirmacion`
            // Temporarily commented out to temporary disable more days trips
            // path = this.nights ? `/mas-de-un-dia/${code}/confirmacion` : `/viaje/${code}/confirmacion`;
          }
          this.$router.push(path).then(() => {
            store.dispatch(SET_STEPPER_LOADING, false);
          });
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit(SET_SNACKBAR, {
            ...store.getters.GET_SNACKBAR,
            text: "No se ha completado el pago",
            color: "error",
            value: true,
          });
        })
        .finally(() => {
          this.$store.dispatch(SET_STEPPER_LOADING, false);
        });
    },
  },
  mounted() {
    const that = this;
    var stripe = Stripe(this.stripeKey, {
      locale: window.appLocale,
    });
    var elements = stripe.elements();

    var cardElement = elements.create("card", {
      hidePostalCode: true,
      style: {
        base: {
          iconColor: "#000",
          color: "#000",
          fontWeight: "300",
          fontFamily: "Avenir, Roboto, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          fontSmoothing: "antialiased",
          ":-webkit-autofill": {
            color: "#000",
          },
          "::placeholder": {
            color: "#A9A9AC",
          },
        },
      },
    });
    cardElement.mount("#card-element");

    cardElement.on("change", ({ error }) => {
      const displayError = document.getElementById("card-errors");
      if (error) {
        displayError.textContent = error.message;
        this.$store.dispatch(SET_STEPPER_LOADING, false);
      }
    });

    this.submitButton = document.getElementById("submit-stripe");

    this.submitButton.addEventListener("click", async (ev) => {
      if (that.cardName == "") {
        var displayError = document.getElementById("card-name-errors");
        displayError != null
          ? (displayError.textContent = "Rellena el campo del nombre")
          : "";
        this.$store.dispatch(SET_STEPPER_LOADING, false);
      } else {
        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
          billing_details: {
            name: that.cardName,
          },
        });

        if (error) {
          that.$store.commit(SET_SNACKBAR, {
            ...store.getters.GET_SNACKBAR,
            text: "No se ha podido completado el pago",
            color: "error",
            value: true,
          });
        } else {
          this.checkoutPayment(paymentMethod, that.cardName);
        }
      }
    });
  },
};
</script>

<style lang="scss">
.my-input {
  border-radius: 4px;
  border: 1px solid rgb(0, 29, 56);
  padding: 14px;
}

#card-name-errors {
  color: #b71c1c;
}

.StripeElement{
  border-color: #9b9b9b !important;
}

.my-input-name {
  border-radius: 4px;
  border: 1px solid rgb(0, 29, 56);
  padding: 11.5px 17px;
  color: black;
  border-color: #9b9b9b;
  ::placeholder {
    font-size: 1em;
  }
}
</style>
